export const initialComplaintsData = {
  kankadahada: 20,
  parjang: 10,
  kamakhyanagar: 18,
  bhuban: 0,
  gondia: 0,
  odapada: 0,
  hindol: 0,
  dhenkanalsadar: 0,

  kantamal: 14,
  boudh: 32,
  harbhanga: 29
};





export const blockDetails = {
  kankadahada: {
    name: "Kankadahada",
    totalComplaints: 20,
    complaints: [
      { id: "DHK-201", type: "Pickpocket", location: "Weekly Market", date: "2024-01-02", status: "Under Investigation" },
      { id: "DHK-202", type: "Road Damage", location: "Mandir Road", date: "2024-01-03", status: "Resolved" }
    ]
  },

  parjang: {
    name: "Parjang",
    totalComplaints: 10,
    complaints: [
      { id: "DHK-211", type: "Water Issue", location: "Ward-5", date: "2024-01-05", status: "New" }
    ]
  },

  kamakhyanagar: {
    name: "Kamakhyanagar",
    totalComplaints: 18,
    complaints: [
      { id: "DHK-221", type: "Street Light Failure", location: "Main Road", date: "2024-01-06", status: "Under Investigation" }
    ]
  },

  bhuban: {
    name: "Bhuban",
    totalComplaints: 0,
    complaints: []
  },

  gondia: {
    name: "Gondia",
    totalComplaints: 0,
    complaints: []
  },

  odapada: {
    name: "Odapada",
    totalComplaints: 0,
    complaints: [
      { id: "DHK-231", type: "Drainage Problem", location: "Odapada Bazar", date: "2024-01-04", status: "Under Investigation" }
    ]
  },

  hindol: {
    name: "Hindol",
    totalComplaints: 0,
    complaints: [
      { id: "DHK-241", type: "Garbage Issue", location: "College Road", date: "2024-01-07", status: "New" }
    ]
  },

  dhenkanalsadar: {
    name: "Dhenkanal-Sadar",
    totalComplaints: 0,
    complaints: []
  },

  /* ---------- YOUR EXISTING BLOCKS ---------- */

  kantamal: {
    name: "Kantamal",
    totalComplaints: 14,
    complaints: [
      { id: "KHD-101", type: "Pickpocket", location: "Kantamal Main Market", date: "2024-01-15", status: "Under Investigation" }
    ]
  },

  boudh: {
    name: "Boudh",
    totalComplaints: 32,
    complaints: [
      { id: "KHD-103", type: "Pickpocket", location: "Central Market", date: "2024-01-16", status: "Under Investigation" }
    ]
  },

  harbhanga: {
    name: "Harbhanga",
    totalComplaints: 29,
    complaints: [
      { id: "KHD-105", type: "Pickpocket", location: "Shopping Complex", date: "2024-01-17", status: "Under Investigation" }
    ]
  }
};